import { CSSObject } from '@emotion/react';
import theme from './theme';

const globalStyles = {
  '*': {
    boxSizing: 'border-box',
  },
  'h1,h2,h3,h4,h5': {
    padding: 0,
    margin: 0,
  },
  body: {
    backgroundColor: theme.colors.light,
    fontFamily: theme.font.family,
    margin: 0,
    padding: 0,
  },
} as CSSObject;

export default globalStyles;
